import { render, staticRenderFns } from "./kpiEdit.vue?vue&type=template&id=2b52d79a"
import script from "./kpiEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./kpiEdit.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./kpiEdit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxMenuTranslate: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/menu/Translate.vue').default,IxTiptapEditor: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/tiptapEditor.vue').default,MetricsFormulaReadable: require('/home/runner/work/assessment-service/assessment-service/frontend/components/metrics/FormulaReadable.vue').default,IxComboboxValueOptions: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/combobox-value-options.vue').default,IxBtnToggleKpiGoalType: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/btn/ToggleKpiGoalType.vue').default,IxSelectCategory: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/select/Category.vue').default,IxSurveyQuestion: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/survey/Question.vue').default})
